import ChoiceHelper from "../../helpers/ChoiceHelper";
import { Card, FormLayout, Layout, Select, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import Switch from "react-switch/index";
import HeadingHelper from "../../helpers/HeadingHelper";
import React from "react";

const SRPayment = props => {
  const {
    validatorClass,
    refundMethods,
    partialRefunds,
    warrantyRequiresRMA, claimPeriod, durationOfConventionalWarranty,
    handleChange, handleSelectChange,
  } = props;
  const refundMethodSelected = ChoiceHelper.selectedFirst(refundMethods);

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("return.annotate.title.payment")}
      description={CsI18n.t('return.annotate.desc.payment')}>
      <Layout.Section>
        <Card sectioned>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <Select
                label={CsI18n.t('Refund methods')}
                options={ChoiceHelper.choices(refundMethods)}
                value={refundMethodSelected}
                onChange={handleSelectChange('refundMethods')}
              />
              <div>
                {HeadingHelper.ptt('Partial refunds', 'return.explain.partial_refunds')}
                <Switch
                  className="react-switch"
                  onChange={handleChange('partialRefunds')}
                  checked={partialRefunds}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  aria-label={CsI18n.t('Partial refunds')}
                />
              </div>
              <FormLayout.Group title={HeadingHelper.h3('Warranty')}>
                <div>
                  {HeadingHelper.ptt('Refund requires RMA', 'return.explain.requires_rma')}
                  <Switch
                    className="react-switch"
                    onChange={handleChange('warrantyRequiresRMA')}
                    checked={warrantyRequiresRMA}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Refund requires RMA")}
                  />
                </div>
              </FormLayout.Group>
              <FormLayout.Group>
                <div className="input-small">
                  <V>
                    <TextField
                      label={HeadingHelper.ltt('Claim period', 'shipping.explain.claim_period')}
                      type="number" suffix={CsI18n.t('days')} min={1}
                      onChange={handleChange("claimPeriod")}
                      value={claimPeriod}
                    />
                    <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                    <V.Item rule="number" title={CsI18n.t("Number only.")} />
                    <V.Item rule="min" min={1} title={CsI18n.t("Too low number.")} />
                  </V>
                </div>
                <div className="input-small">
                  <V>
                    <TextField
                      label={HeadingHelper.ltt('Duration of conventional warranty', 'shipping.explain.conventional_duration_warranty')}
                      type="number" suffix={CsI18n.t('years')} min={1}
                      onChange={handleChange("durationOfConventionalWarranty")}
                      value={durationOfConventionalWarranty}
                    />
                    <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                    <V.Item rule="number" title={CsI18n.t("Number only.")} />
                    <V.Item rule="min" min={1} title={CsI18n.t("Too low number.")} />
                  </V>
                </div>
              </FormLayout.Group>
            </FormLayout>
          </CsValidationForm>
        </Card>
      </Layout.Section>
    </Layout.AnnotatedSection>
  )
};

export default SRPayment;